'use client';

import { motion } from 'framer-motion';
import { useSafeNavigation } from '@/hooks/useSafeNavigation';
import { LabItem } from '@/types/labs';
import { NoData } from '@/components/NoData';
import LabListUnit from '@/(routers)/labs/list/components/unit/LabListUnit';

export interface LabListSearchResultsProps {
    dataList: LabItem[] | null;
}

export default function LabListSearchResults({ dataList }: LabListSearchResultsProps) {
    const { safePush } = useSafeNavigation();

    return (
        <div className="flex w-[96%] md:w-[98%] h-full justify-center items-start pb-2">
            {dataList && dataList?.length > 0 ? (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-8 md:gap-4"
                >
                    {dataList.map((data) => (
                        <motion.div
                            key={data.lab_id}
                            className="relative flex w-full rounded-xl bg-color-white-base md:shadow-full"
                            onClick={() => {
                                safePush(`/labs/detail/${data.lab_id}`);
                            }}
                        >
                            <LabListUnit data={data} />
                        </motion.div>
                    ))}
                </motion.div>
            ) : (
                <NoData message="該当するラボが見つかりませんでした。" />
            )}
        </div>
    );
}
